// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import AttendanceOverTime from "entity/AttendanceOverTime";
import AttendeeCSVList from "entity/AttendeeCSVList";
import CompanyRepresented from "entity/CompanyRepresented";
import FilterList from "entity/FilterList";
import MeetingSummaryStatus from "enums/MeetingSummaryStatus";
import Participation from "entity/Participation";
import SocialFile from "./SocialFile";
import SpeechGroup from "entity/SpeechGroup";
import Util from "PreciateUtil";

export default interface MeetingHostSummary {
    hostSummaryId?: string;
    setId?: string;
    setName?: string;
    companyId?: string;
    startTime?: Date;
    status?: MeetingSummaryStatus;
    totalAttendees?: number;
    participation?: Participation;
    attendanceOverTime?: AttendanceOverTime[];
    companiesRepresented?: CompanyRepresented[];
    filterList?: FilterList[];
    attendeeCsvList?: AttendeeCSVList[];
    socialFileList?: SocialFile[];
    fullMeetingSummary?: string;
    fullMeetingKeywords?: string[];
    attendanceOverview?: string;
    speechGroups?: SpeechGroup[];
}

export function processMeetingHostSummary(value?: MeetingHostSummary): void {
  if (value) {
    value.startTime = Util.toDate((value as any).startTime);
  }
}

export function processMeetingHostSummaryArray(array?: MeetingHostSummary[]): void {
  if (array) {
    for (const v of array) {
      processMeetingHostSummary(v);
    }
  }
}
